import { useEffect, useRef, useState } from "react";

export const useAgGridPagingPanel = () => {
  const gridContainerRef = useRef<HTMLDivElement>(null);
  const [pagingPanel, setPagingPanel] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const container = gridContainerRef.current;
    if (!container) {
      return undefined;
    }
    const findPanel = () => {
      const panel = container.querySelector<HTMLElement>(".ag-paging-panel");
      setPagingPanel(prev => (prev === panel ? prev : panel));
    };
    findPanel();
    const mutationObserver = new MutationObserver(findPanel);
    mutationObserver.observe(container, { childList: true, subtree: true });
    return () => mutationObserver.disconnect();
  }, []);

  return { gridContainerRef, pagingPanel };
};
